import React from 'react';
import { connect } from "react-redux";
import Loader from './../../../Global/loader.js'
import { FaPlus } from 'react-icons/fa'
import { store } from 'react-notifications-component';
import BootstrapTable from 'react-bootstrap-table-next';
import businessPremisesList from './../../../API/Admin/GetBusinessPremisesList'
import { AiFillEdit } from 'react-icons/ai'
import { RiDeleteBin5Line } from 'react-icons/ri'
import Modal from 'react-modal';
import deletePosProstor from './../../../API/Admin/DeletePoslovniProstor'
import { Button } from 'react-bootstrap'
import CreatePosProstor from './CreatePosProstor.js'
import UpdatePosProstor from './UpdatePosProstor.js'
import { BsBackspaceFill } from 'react-icons/bs'

class PosProstor extends React.Component {
    state={
        loading: true,
        create: false,
        showDeleteModal: false,     
        uuidForDelete: "",  
        showOnePosPro: false,
        
        customStyles: {
            content : {
                top                   : '50%',
                left                  : '50%',
                right                 : 'auto',
                bottom                : 'auto',
                //marginRight           : '-50%',
                transform             : 'translate(-50%, -50%)',
                color: 'red'
            }
        },

        columns:[{
            dataField: 'label',
            text: 'Oznaka',
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"}         
          }, {
            dataField: 'address',
            text: 'Adresa',
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"} 
        }, {
          dataField: 'premises_name',
          text: 'Premises Name',
          style: {wordWrap: "break-word"},
          headerStyle: {wordWrap: "break-word"}   
        }, {
            dataField: 'description',
            text: 'Opis',
            style: {wordWrap: "break-word"},
            headerStyle: {wordWrap: "break-word"}
        }, {
            dataField: 'ecommerce',
            text: 'E-commerce',
            headerStyle: {wordWrap: "break-word"},    
            formatter: (cellContent, row) => {          
                return (
                    <div key={row.uuid} style={{wordWrap: "break-word"}}>
                        <span style={{ color: row.ecommerce ? "green": "red"}}>
                            <strong>
                                { !row.ecommerce ?  'Ne' : 'Da' }
                            </strong>
                        </span>
                    </div>
                );
            }
        }, {
            dataField: 'pregled',
            isDummyField: true,
            text: '',
            headerStyle: (colum, colIndex) => {
                return { width: '11em' };
            },
            formatter: (cellContent, row) => {          
              return (
                <div key={row.uuid} style={{wordWrap: "break-word"}}>
                    <div 
                        className="btn btn-warning" 
                        id={row.uuid} 
                        onClick={() =>this.seeDetails(row)} 
                        style={{marginBottom: "10px", marginRight: "10px", fontSize: "13px"}}
                    > 
                        <AiFillEdit /> Detalji 
                    </div> 

                    <div 
                        className="btn btn-danger"
                        id={row.uuid}
                        onClick={() => this.showDeleteModal(row.uuid)}
                        style={{marginBottom: "10px", fontSize: "13px"}}
                    >
                        <RiDeleteBin5Line /> Izbriši
                    </div> 
                   
                </div>
                
              );
            }
        }]        
        
    }

    componentDidMount = async () => {
        this.setState({loading: true})    
        let lista = await businessPremisesList(this.props.oneClientInfo.uuid)
        if(lista.data.length > 0){
            this.props.mapState("ADMIN_MAP_POS_PRO_LIST", lista.data)
        }
        else{
            this.props.mapState("ADMIN_MAP_POS_PRO_LIST", [])
            /*
            store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom dohvata Poslovnih Prostora, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            })
            */
        }

        this.setState({
            loading: false
        })
         
    }

    toggleCreate(){
        this.setState({
            create: !this.state.create
        })
    }

    backFromCreate(){
        this.setState({
            create: !this.state.create
        })
        this.componentDidMount()
    }

    showDeleteModal = uuid => {
        this.setState({
            showDeleteModal: !this.state.showDeleteModal,
            uuidForDelete: uuid
        });
    };

    confirmDelete = async () => {
        let deletedPosProstor = await deletePosProstor(this.props.oneClientInfo.uuid, this.state.uuidForDelete)   
        if(deletedPosProstor.data.operationResult !== "SUCCESS"){
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            })     
            await store.addNotification({
                title: "Greška!",
                message: "Došlo je do pogreške prilikom Brisanja Poslovnog Prostora, molimo pokušajte ponovno.",
                type: "danger",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 15000,
                  onScreen: true
                }
            }) 
        }
        else{
            await this.setState({
                showDeleteModal: false,
                uuidForDelete: ""
            }) 

            await store.addNotification({
                title: "Uspješno!",
                message: "Brisanje poslovnog prostora je izvršeno.",
                type: "success",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 5000,
                  onScreen: true
                }
            }) 

            this.componentDidMount()
        }
    }

    seeDetails = async (data) => {
        await this.props.mapState("ADMIN_MAP_ONE_POSLOVNI_PROSTOR", data)
        await this.setState({
            showOnePosPro: !this.state.showOnePosPro
        })
    }

    backFromEdit = async () =>{
        await this.setState({
            showOnePosPro: !this.state.showOnePosPro
        })

        this.componentDidMount()
    }

    goBack(){
        window.location = "#/Admin/client/"
    }
   
    render(){  
        const { loading, create, showOnePosPro } = this.state 

    return (
        <>
        {loading ? 
            <Loader />
        :
            <>
                {showOnePosPro? 
                    <UpdatePosProstor goBack={() => this.backFromEdit()} />
                :
                create ? 
                    <CreatePosProstor goBack={() => this.backFromCreate()} />
                :
                    <>

                        <div style={{padding:"20px", float: "right"}}>
                            <div className="btn btn-success" style={{fontSize: "16px"}} onClick={() => this.toggleCreate()}>
                                <FaPlus size={20} /> <span style={{verticalAlign: "middle"}} >Kreiraj</span>
                            </div>
                        </div>

                        <BootstrapTable
                            keyField="uuid" 
                            data={ this.props.posProstorList } 
                            columns={ this.state.columns }   
                            bodyStyle={{wordBreak: 'break-word'} }                    
                        />

                        <Modal
                            isOpen={this.state.showDeleteModal}                
                            onRequestClose={() => this.showDeleteModal("")}
                            style={this.state.customStyles}
                            contentLabel="Example Modal"
                        >
            
                            <h1 style={{padding:"20px"}}><strong>Upozorenje!</strong></h1>
                        
                            <div className="" style={{padding: "20px"}}>
                                Brisanjem poslovnog prostora obrisat će se i ostali podaci koji su vezani uz njega.                                
                            </div>

                            <div className="row">
                                <div className="col col-sm-6">
                                    <Button variant="primary" size="lg" onClick={() => this.showDeleteModal("")}>Zatvori</Button>
                                </div>
                                <div className="col col-sm-6">
                                    <Button variant="danger" size="lg" onClick={() => this.confirmDelete()}> IZBRIŠI</Button>
                                </div>                
                            </div>
                    
                        </Modal> 

                        <div 
                            className="btn btn-default" 
                            style={{/*width: "100%",*/ marginBottom: "10px", marginTop: "10px"}}
                            onClick={() => this.goBack()}
                        >
                            <BsBackspaceFill size={30} />  <strong>Nazad</strong>                    
                        </div>      
                    </>
                } 
                         
            </>
        }
        </>
    )
}
}
const mapStateToProps = state => {
    return {
        oneClientInfo: state.adminClient.oneClient,
        posProstorList: state.adminClient.posProstorList,
        onePosPro: state.adminClient.onePosPro
    };
};
  
const mapDispatchToProps = dispatch => {
    return {
        mapState: (type, data) => dispatch({ type: type, data: data}),
        API: (type, data) => dispatch({ type: type, data: data})
    };
};
  
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(PosProstor);